import { environment } from '@environments/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { RsSentry } from '@lib/utils/rs-senty-init';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';

new RsSentry({
  dsn: 'https://34ee7c4c329447a8a16fac7b7a2a28cd@o268277.ingest.sentry.io/1813332',
  enabled: environment.enableSentryMonitoring,
  environment: environment.environment,
  sentryReleaseName: environment.sentryReleaseName
}).sentryInit();

Sentry.getCurrentScope().setTag('app.name', 'ORD');
Sentry.getCurrentScope().setTag('app.environment', environment.environment);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(error => console.error(error));
